import type { CSSProperties } from "react";
import { FaSpinner } from "react-icons/fa";
import "./spinner.style.scss";

interface SpinnerProps {
	styles?: CSSProperties;
}

function Spinner({ styles }: SpinnerProps) {
	return (
		<p className="spinner" id="spinner" style={styles}>
			<FaSpinner />
		</p>
	);
}

export default Spinner;
